module.exports = __webpack_public_path__ + "static/media/esahyogiblue.097c477c.svg";